import styles from "./styles.module.scss";

const ReviewStarsInput = ({ title, rating, setRating }) => {
  const handleStarClick = (value) => {
    setRating(value);
  };

  return (
    <div className={styles.reviewContainer}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.stars}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => (
          <span
            key={value}
            className={`${styles.star} ${
              value <= rating ? styles.full : styles.empty
            }`}
            onClick={() => handleStarClick(value)}
          ></span>
        ))}
      </div>
      <span className={styles.rating}>({rating} / 10)</span>
    </div>
  );
};

export default ReviewStarsInput;